<template>
  <div class="row">
    <div class="col-md-3 col-lg-2">
      <MemberProfilesNav :tabs="setting_tabs" />
    </div>
    <div class="col-md-8 col-sm-9 col-lg-10 border-left pl-lg-30 setting_wrapper settings_panel">
      <div class="d-sm-flex justify-content-between">
        <div class="mb-10">
          <h5 class="setting-title">Member Profiles</h5>
          <p class="text-muted">Add or edit custom fields that appear on member profiles</p>
        </div>

        <div class="d-flex d-sm-block">
          <AppButton
            id="new-member-field"
            class="flex-1"
            type="primary"
            @click="onShowNewMemberProfileFieldDialog"
          >
            Add custom field
          </AppButton>
        </div>
      </div>

      <AppTableLoading
        v-if="loading"
        :columns="4"
      ></AppTableLoading>

      <MemberProfileFieldsTable
        v-else
        :show-loading="loading"
        :member-profile-fields="member_profile_fields"
        @open-edit-dialog="onShowEditMemberProfileFieldDialog"
        @open-delete-dialog="onShowDeleteMemberProfileFieldDialog"
      />

      <MemberProfileFieldDialog
        v-if="showNewMemberProfileFieldDialog"
        id="new-member-profile-field"
        key="create-pf-dialog"
        @close="onCloseNewMemberProfileFieldDialog"
      />

      <MemberProfileFieldDialog
        v-if="showEditMemberProfileFieldDialog"
        id="edit-member-profile-field"
        key="edit-pf-dialog"
        editing
        :member-profile-field="memberProfileField"
        @close="onCloseEditMemberProfileFieldDialog"
        @show-delete-dialog="onShowDeleteMemberProfileFieldDialog"
      />

      <DeleteMemberProfileFieldDialog
        v-if="showDeleteMemberProfileFieldDialog"
        id="delete-member-profile-field"
        key="delete-pf-dialog"
        :member-profile-field="memberProfileField"
        @close="onCloseDeleteMemberProfileFieldDialog"
        @close-edit-dialog="onCloseEditMemberProfileFieldDialog"
      />
    </div>
  </div>
</template>

<script>
// Inertia helpers/utils
import { InertiaFlashWatcher, InertiaLoadingWatcher } from '~/utils/inertia';
// Components
import MemberProfileFieldsTable from '~/components/members/MemberProfileFieldsTable.vue';
import MemberProfileFieldDialog from '~/components/members/MemberProfileFieldDialog.vue';
import DeleteMemberProfileFieldDialog from '~/components/members/DeleteMemberProfileFieldDialog.vue';
import MemberProfilesNav from '~/components/settings/MemberProfilesNav.vue';

export default {
  name: 'MemberProfiles',
  components: {
    MemberProfilesNav,
    MemberProfileFieldsTable,
    MemberProfileFieldDialog,
    DeleteMemberProfileFieldDialog,
  },
  mixins: [InertiaFlashWatcher, InertiaLoadingWatcher],
  props: {
    member_profile_fields: {
      type: Array,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
    setting_tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      memberProfileField: null,
      showNewMemberProfileFieldDialog: false,
      showEditMemberProfileFieldDialog: false,
      showDeleteMemberProfileFieldDialog: false,
    };
  },
  computed: {
    noMemberProfileFields() {
      return (this.member_profile_fields || []).length === 0;
    },
  },
  methods: {
    onShowNewMemberProfileFieldDialog() {
      this.showNewMemberProfileFieldDialog = true;
    },
    onCloseNewMemberProfileFieldDialog() {
      this.showNewMemberProfileFieldDialog = false;
    },
    onShowEditMemberProfileFieldDialog(customField) {
      this.memberProfileField = customField;
      this.showEditMemberProfileFieldDialog = true;
    },
    onCloseEditMemberProfileFieldDialog() {
      this.showEditMemberProfileFieldDialog = false;
    },
    onShowDeleteMemberProfileFieldDialog(customField) {
      this.memberProfileField = customField;
      this.showDeleteMemberProfileFieldDialog = true;
    },
    onCloseDeleteMemberProfileFieldDialog() {
      this.showDeleteMemberProfileFieldDialog = false;
    },
  },
};
</script>
